import BillingAddressView from './BillingAddressView';

export default BillingAddressView;
